import { call, put, delay } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import {
  listPoints,
  getPointById,
  createPoint,
  cancelPoint,
  getUserBalance,
  getUserPoints,
  setPointMaturity,
  batchPostPoints,
  batchCancelPoints,
  calculatePointValue,
} from '../requests/rewardService'
import {
  setPoints,
  setPointDetail,
  setUserBalance,
  setUserPoints,
  setLoading,
  setError,
  setMaturityLoading,
  setBatchPostLoading,
  setBatchCancelLoading,
  setCalculateLoading,
} from '../../slices/rewardPointsSlice'

function getErrorMessage(e) {
  try {
    const msg = e.response?.data?.message || e.response?.data?.error || e.message
    return typeof msg === 'string' ? msg : String(msg)
  } catch {
    return 'An unexpected error occurred'
  }
}

export function* handleFetchPoints(action) {
  try {
    yield put(setLoading(true))
    const params = { page: 1, per_page: 10, ...action.payload }
    const { data } = yield call(listPoints, params)
    yield put(setPoints(data))
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleFetchPointById(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(getPointById, action.payload)
    yield put(setPointDetail(data))
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleCreatePoint(action) {
  try {
    yield put(setLoading(true))
    yield call(createPoint, action.payload)
    yield put(setLoading(false))
    toast.success('Point entry created successfully')
  } catch (e) {
    yield put(setLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}

export function* handleCancelPoint(action) {
  try {
    yield put(setLoading(true))
    const { pointId, sourceSystem } = action.payload
    yield call(cancelPoint, pointId, sourceSystem)
    yield put(setLoading(false))
    toast.success('Point entry cancelled successfully')
  } catch (e) {
    yield put(setLoading(false))
    const errorMsg = getErrorMessage(e)
    toast.error(errorMsg)
    yield put(setError(errorMsg))
  }
}

export function* handleFetchUserBalance(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(getUserBalance, action.payload)
    yield put(setUserBalance(data))
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleFetchUserPoints(action) {
  try {
    yield put(setLoading(true))
    const { userId, params } = action.payload
    const { data } = yield call(getUserPoints, userId, params)
    yield put(setUserPoints(data))
    yield put(setLoading(false))
  } catch (e) {
    yield put(setLoading(false))
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleSetMaturity(action) {
  try {
    yield put(setMaturityLoading(true))
    yield call(setPointMaturity, action.payload)
    yield put(setMaturityLoading(false))
    toast.success('Maturity date set successfully')
  } catch (e) {
    yield put(setMaturityLoading(false))
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleBatchPost(action) {
  try {
    yield put(setBatchPostLoading(true))
    yield call(batchPostPoints, action.payload)
    yield put(setBatchPostLoading(false))
    toast.success('Points batch posted successfully')
  } catch (e) {
    yield put(setBatchPostLoading(false))
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleBatchCancel(action) {
  try {
    yield put(setBatchCancelLoading(true))
    yield call(batchCancelPoints, action.payload)
    yield put(setBatchCancelLoading(false))
    toast.success('Points batch cancelled successfully')
  } catch (e) {
    yield put(setBatchCancelLoading(false))
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleCalculate(action) {
  try {
    yield put(setCalculateLoading(true))
    yield call(calculatePointValue, action.payload)
    yield put(setCalculateLoading(false))
    toast.success('Points calculated successfully')
  } catch (e) {
    yield put(setCalculateLoading(false))
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}
